import type { StepStatus, TemplatePage } from "./types";

export const API_SCOPE =
  process.env.REACT_APP_API_SCOPE ||
  import.meta.env.VITE_API_SCOPE ||
  "api://b4d2b9e7-957c-46dd-976c-9eec1f46ac72/jdx_portal_user_impersonation";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  (process.env.NODE_ENV === "development" ? "" : "http://localhost:7071");

export const statusStyles: Record<StepStatus, string> = {
  planned:
    "border-slate-200 bg-slate-100 text-slate-600 dark:border-white/10 dark:bg-white/10 dark:text-slate-300",
  running:
    "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/30 dark:bg-blue-500/10 dark:text-blue-300",
  needs_approval:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-yellow-500/30 dark:bg-yellow-500/10 dark:text-yellow-300",
  validated:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-300",
  failed:
    "border-red-200 bg-red-50 text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-300",
};

export const templatePages: TemplatePage[] = [
  {
    key: "shipment-control-tower",
    title: "Shipment Control Tower",
    route: "/shipments",
    componentName: "ShipmentControlTowerTemplate",
    description:
      "Shipment visibility portal met zendingen, containers, ETA’s, milestones en exceptions.",
    iconKey: "shipWheel",
    previewType: "shipment-control-tower",
  },
  {
    key: "documents",
    title: "Document Center",
    route: "/documents",
    componentName: "DocumentsTemplate",
    description: "Rapportages, exports, uploads en downloads.",
    iconKey: "fileText",
    previewType: "documents",
  },
  {
    key: "users-access",
    title: "Users & Access",
    route: "/users",
    componentName: "UsersAccessTemplate",
    description: "Beheer van gebruikers, rollen en toegang tot de portal.",
    iconKey: "users",
    previewType: "users-access",
  },
  {
    key: "settings",
    title: "Settings",
    route: "/settings",
    componentName: "SettingsTemplate",
    description: "Portalconfiguratie, thema, klantinstellingen en toggles.",
    iconKey: "settings",
    previewType: "settings",
  },
];
